import { maxLength, ValidationField, Validator } from "~/extensions/utils";
export class ResponseFindConditionValidator extends Validator {
    constructor(data) {
        const constrains = {
            userName: {
                length: maxLength(30)
            },
            responseReason: {
                length: maxLength(50)
            }
        };
        super(data, constrains);
        this.userName = new ValidationField("userName", data, constrains);
        this.responseReason = new ValidationField("responseReason", data, constrains);
    }
    userName;
    responseReason;
}
